<div class="donate-container" fxLayout="row wrap" fxLayoutAlign="center top" fxLayoutGap="5px">
  <div fxFlex.xs="100%" fxFlex.sm="15%" fxFlex.md="15%" fxFlex.lg="15%" fxFlex.gt-lg="15%">
    <div class="img-container">
      <img src="../../../assets/me.jpg" alt="me"/>
    </div>
  </div>

  <div fxFlex.xs="100%" fxFlex.sm="55%" fxFlex.md="55%" fxFlex.lg="55%" fxFlex.gt-lg="55%">
    <p class="text">Big thanks for donations and kind words to</p>
    <ul>
      <li>Cord</li>
      <li>Bonita from Amazing Women's Network</li>
      <li>Simon</li>
      <li>Joshua</li>
      <li>Mário</li>
      <li>Trisha</li>
      <li>Brian</li>
      <li>Jude</li>
    </ul>
  </div>

  <div fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" fxFlex.lg="25%" fxFlex.gt-lg="25%">
    <div class="donate-button-container">
      <div id="home-donate-button"></div>
    </div>

    <p class="text">
      I'd like to say a massive thanks for using my website. I'm looking for some help in maintaining and improving the
      website. Any penny is deeply appreciated!
    </p>
    <p class="text">
      To learn more about me and my plans,
      <a href="about" routerLink="/about">click here</a>. Thanks!
    </p>
  </div>
</div>
